import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let webApiUrl = `${process.env.REACT_APP_BASE_URL}stack`;
let tokenStr = process.env.REACT_APP_API_TOKEN;

export const fetchStacks = createAsyncThunk("stacks/fetchStacks", () => {
  return axios
    .get(webApiUrl, { headers: { Authorization: `Token ${tokenStr}` } })
    .then((response) => response.data);
});
const stacksSlice = createSlice({
  name: "stacks",
  initialState: {
    stacksLoading: true,
    stacksData: {
      OPEDA: [],
      OPSGA: [],
    },
    stacksError: "",
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchStacks.pending,
      (state) => {
        state.stacksLoading = true;
      },
      builder.addCase(
        fetchStacks.fulfilled,
        (state, action) => {
          state.stacksLoading = false;
          state.stacksData = action.payload;
          state.stacksError = "";
        },
        builder.addCase(fetchStacks.rejected, (state, action) => {
          state.stacksLoading = false;
          state.stacksData = [];
          state.stacksError = action.error.message;
        })
      )
    );
  },
});
export default stacksSlice.reducer;
